import React from "react";
import { motion } from "framer-motion";

const AnimateOnClick = ({ children, whileTap, whileHover, ...props }) => {
  return (
    <motion.div whileTap={whileTap} whileHover={whileHover} {...props}>
      {children}
    </motion.div>
  );
};

AnimateOnClick.defaultProps = {
  whileTap: { scale: 0.95 },
  whileHover: { scale: 1.03 },
};

export default AnimateOnClick;
